var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"n2-center-container"},[_c('h3',[_vm._v(_vm._s(_vm.$t('components.app.unauthorized.title')))]),_c('p',[_vm._v(_vm._s(_vm.$t('components.app.unauthorized.description')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }